module.exports = __webpack_public_path__ + "static/media/import-doc.9454de8f.svg";